import type { Verdict } from '@sr-test-wizard/shared';
import { VERDICT_CSS, VERDICT_LABEL, VERDICT_VALUES } from '@sr-test-wizard/shared';

interface Props {
  value: Verdict | null;
  onChange: (verdict: Verdict) => void;
  disabled?: boolean;
}

export function VerdictPicker({ value, onChange, disabled }: Props) {
  return (
    <div className="verdict-grid">
      {VERDICT_VALUES.map((verdict) => {
        const selected = verdict === value;
        return (
          <label key={verdict} className={selected ? 'selected' : ''}>
            <input
              type="radio"
              name="verdict"
              checked={selected}
              disabled={disabled}
              onChange={() => onChange(verdict)}
              style={{ accentColor: 'var(--accent)' }}
            />
            <span className={`dot ${VERDICT_CSS[verdict]}`} />
            <span>{VERDICT_LABEL[verdict]}</span>
          </label>
        );
      })}
    </div>
  );
}
